import React from 'react';
import { useAuth } from '@clerk/clerk-react';
import { SignIn } from './SignIn';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isSignedIn) {
    return <SignIn />;
  }

  return <>{children}</>;
};